import { notImplementedFunc, } from "./util";
export default ({ repositoryInstance, normalizeEntityPayload, basePath, pathModifiers = {}, utils, defaultListParams, }) => {
    const paths = Object.assign({ create: () => "", edit: (payload) => `/${payload.id}`, getById: (id) => `/${id}`, getAll: () => "/all", getList: () => "" }, pathModifiers);
    function create(payload) {
        return normalizeEntityPayload
            ? repositoryInstance.post(`${basePath}${paths.create(payload)}`, normalizeEntityPayload(payload, "post"))
            : notImplementedFunc();
    }
    function edit(payload) {
        return normalizeEntityPayload
            ? repositoryInstance.patch(`${basePath}${paths.edit(payload)}`, normalizeEntityPayload(payload, "patch"))
            : notImplementedFunc();
    }
    function getById(id) {
        return repositoryInstance.get(`${basePath}${paths.getById(id)}`);
    }
    function getList(params) {
        return utils.getWithParams(`${basePath}${paths.getList(params)}`, params, defaultListParams);
    }
    function getAll(timeout) {
        return repositoryInstance.get(`${basePath}${paths.getAll(undefined)}`, {
            timeout,
        });
    }
    return Object.freeze({
        create,
        edit,
        getById,
        getList,
        getAll,
    });
};
//# sourceMappingURL=basicEntity.js.map